import type { TCommunicationTemplate } from "@bbj-types/communication";
import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { axiosCommunication } from "./axios";
import type { TGetCommunicationTemplates } from "./getCommunicationTemplates";

type TPatchCommunicationTemplateBody = Partial<Pick<TCommunicationTemplate, "content" | "name" | "subject">>;

export const usePatchCommunicationTemplate = () => {
  const [state, execute, cancel] = axiosCommunication<
    TGetCommunicationTemplates,
    TPatchCommunicationTemplateBody,
    unknown
  >(
    {
      method: "PATCH",

      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (workshopsId: ObjectId, data: TPatchCommunicationTemplateBody) => {
      return execute({
        url: `/templates/${workshopsId}`,
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
